// Coordinate validation and parsing utilities

/**
 * Check if a latitude value is valid
 * @param lat - Latitude value
 * @returns True if valid
 */
export function isValidLatitude(lat: number): boolean {
  return !isNaN(lat) && lat >= -90 && lat <= 90;
}

/**
 * Check if a longitude value is valid
 * @param lng - Longitude value
 * @returns True if valid
 */
export function isValidLongitude(lng: number): boolean {
  return !isNaN(lng) && lng >= -180 && lng <= 180;
}

/**
 * Check if coordinates are valid
 * @param lat - Latitude value
 * @param lng - Longitude value
 * @returns True if both are valid
 */
export function isValidCoordinates(lat: number, lng: number): boolean {
  return isValidLatitude(lat) && isValidLongitude(lng);
}

/**
 * Parse a value to a number safely
 * @param value - Value to parse
 * @returns Parsed number or NaN
 */
export function parseCoordinate(value: unknown): number {
  if (typeof value === 'number') {
    return value;
  }
  return parseFloat(String(value));
}

/**
 * Format coordinates for display
 * @param lat - Latitude
 * @param lng - Longitude
 * @param precision - Decimal places (default: 6)
 * @returns Formatted string
 */
export function formatCoordinates(lat: number, lng: number, precision = 6): string {
  return `${lat.toFixed(precision)}, ${lng.toFixed(precision)}`;
}
